import React, { useState, useEffect } from "react"; 
import { useNavigate } from "react-router-dom";
import {
  FaRocket,
  FaGlobe,
  FaChartLine,
  FaUniversity,
  FaCogs
} from "react-icons/fa";
import "./Projects.css";

import img1 from "../uploads/xml-conversion-services-884.jpg";
import img2 from "../uploads/wwww.jpg";
import img3 from "../uploads/dingding.jpg";
import img4 from "../uploads/4.jpg";
import img5 from "../uploads/5.jpg";

function Projects() {
  const [selectedProject, setSelectedProject] = useState(null);
  const navigate = useNavigate();

  
  useEffect(() => {
    if (selectedProject) {
      document.body.style.overflow = "hidden";
      document.body.classList.add("card-modal-open");
    } else {
      document.body.style.overflow = "auto";
      document.body.classList.remove("card-modal-open");
    }

    return () => {
      document.body.style.overflow = "auto";
      document.body.classList.remove("card-modal-open");
    };
  }, [selectedProject]);

  const projects = [
    {
      icon: <FaGlobe />,
      title: "XML & ePub Publishing Automation",
      short: "Automated XML workflow for large-scale digital publishing.",
      full: `
Designed and implemented an end-to-end XML and ePub conversion pipeline for publishers.

• XML conversion (JATS / BITS / DocBook)
• Automated ePub3 generation
• Multi-format output (PDF, HTML, ePub)
• Metadata & indexing automation

Enabled faster publishing cycles and consistent multi-channel distribution.
      `,
      image: img1
    },
    {
      icon: <FaUniversity />,
      title: "PDF Accessibility Compliance (WCAG)",
      short: "Making digital documents accessible for all users.",
      full: `
Delivered full-scale PDF accessibility remediation aligned with WCAG standards.

• Tagged PDF structuring
• Screen reader compatibility (JAWS/NVDA)
• Alt text for images & tables
• Reading order correction

Ensured compliance with WCAG 2.1 and ADA accessibility standards.
      `,
      image: img2
    },
    {
      icon: <FaChartLine />,
      title: "Invoice Processing Automation",
      short: "Streamlining invoice handling using smart automation.",
      full: `
Developed an intelligent invoice processing system to reduce manual effort.

• OCR-based data extraction
• Automated invoice validation
• ERP system integration
• Real-time tracking dashboard

Reduced processing time and minimized human errors significantly.
      `,
      image: img3
    },
    {
      icon: <FaRocket />,
      title: "Digital Content Transformation",
      short: "Transforming legacy content into digital-ready formats.",
      full: `
Converted large volumes of legacy documents into structured digital assets.

• PDF to XML / HTML conversion
• Content restructuring
• Semantic tagging
• Quality assurance workflows

Improved usability, searchability, and digital readiness of content.
      `,
      image: img4
    },
    {
      icon: <FaCogs />,
      title: "End-to-End Workflow Optimization",
      short: "Optimizing publishing and data processing workflows.",
      full: `
Re-engineered business workflows for publishing and data operations.

• Automated content pipelines
• API-based integrations
• Cloud deployment solutions
• Performance monitoring dashboards

Enhanced productivity, scalability, and operational efficiency.
      `,
      image: img5
    }
  ];

  const renderContent = (text) => {
    const lines = text.split("\n").filter(line => line.trim() !== "");

    return lines.map((line, index) => {
      if (line.trim().startsWith("•")) {
        return (
          <li key={index}>
            {line.replace("•", "").trim()}
          </li>
        );
      }
      return <p key={index}>{line.trim()}</p>;
    });
  };

  return (
    <div className="projects-wrapper">

      <section className="projects-hero">
        <h1 className="projects-small-title">Our Projects</h1>
        <h2 className="projects-main-title">
          Smart Solutions for Digital Publishing & Automation
        </h2>
        <p>
          We deliver industry-focused solutions in XML conversion, accessibility,
          invoice automation, and digital transformation.
        </p>
      </section>

      <section className="projects-grid">
        {projects.map((project, index) => (
          <div
            key={index}
            className="project-card"
            onClick={() => setSelectedProject(project)}
          >
            <div className="project-image">
              <img src={project.image} alt={project.title} />
            </div>

            <div className="project-content">
              <div className="project-icon">{project.icon}</div>
              <h3>{project.title}</h3>
              <p>{project.short}</p>
              <span>View Case Study →</span>
            </div>
          </div>
        ))}
      </section>

      {selectedProject && (
        <div
          className="modal-overlay"
          onClick={() => setSelectedProject(null)}
        >
          <div
            className="modern-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <div className="modal-title-section">
                <div className="modal-icon">
                  {selectedProject.icon}
                </div>
                <h2>{selectedProject.title}</h2>
              </div>

              <button
                className="close-btn"
                onClick={() => setSelectedProject(null)}
              >
                ✕
              </button>
            </div>

            <div className="modal-body">
              <ul className="feature-list">
                {renderContent(selectedProject.full)}
              </ul>
            </div>

            <div className="modal-footer">
              <button
                className="cta-btn"
                onClick={() => navigate("/contact")}
              >
                Discuss Similar Project →
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

export default Projects;
